// OSFJS: Replace XDM_DEBUG(x)
// #if DEBUG   //add file name and line number to debugg message
// #define XDM_DEBUG(x) // OsfMsAjaxFactory.msAjaxDebug.trace(__FILE__+":"+__LINE__+"|"+(x))  //if needed, uncomment this line.
// #else       //ignore in ship
// #define XDM_DEBUG(x)
// #endif
function XDM_DEBUG(x) {
  OsfMsAjaxFactory.msAjaxDebug.trace(x);
}
//create namespaces
